import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";

// Material Dashboard 3 PRO React components
import MDSnackbar from "components/MDSnackbar";

const VERTICAL = { t: "top", b: "bottom" };
const HORIZONTAL = { l: "left", c: "center", r: "right" };

/**
 * MUI v5 replacement of the v1 Snackbar used for API feedback.
 * Info messages auto-close, errors stay until the user closes them.
 */
export default function Notification({
	color = "info",
	message,
	open,
	onClose,
	place = "br"
}) {
	const isError = color === "danger" || color === "error";
	return (
		<MDSnackbar
			color={isError ? "error" : "info"}
			icon={<Icon>{isError ? "warning" : "notifications"}</Icon>}
			title={isError ? "Erreur" : "Information"}
			content={message || ""}
			dateTime=""
			open={!!open}
			anchorOrigin={{
				vertical: VERTICAL[place[0]] || "bottom",
				horizontal: HORIZONTAL[place[1]] || "right"
			}}
			close={onClose}
			onClose={isError ? undefined : onClose}
		/>
	);
}

Notification.propTypes = {
	color: PropTypes.oneOf(["info", "danger", "error"]),
	message: PropTypes.string,
	open: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	// v1 Snackbar placement: t|b + l|c|r (e.g. "br" = bottom right)
	place: PropTypes.oneOf(["tl", "tc", "tr", "bl", "bc", "br"])
};
